<div class="face" woa-activatable (onActivate)="activate()"
     [woa-css-var]="{
         '--apple-pay-button-type': type(),
         '--apple-pay-button-style': style()
     }">
    @if (isPassive()) {
        <div class="apple-pay-button"></div>
    } @else if (paymentModel.paymentProvider() === IntegratedPaymentProvider.TYRO) {
        <div id="tyro-apple-pay-form-holder"></div>
    }
    @if (showSpinner() || showTyroSpinner()) {
        <woa-spinner class="face-spinner"></woa-spinner>
    }
</div>
